import { render, staticRenderFns } from "./Cargo.vue?vue&type=template&id=93d27848&"
import script from "./Cargo.vue?vue&type=script&lang=js&"
export * from "./Cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d27848')) {
      api.createRecord('93d27848', component.options)
    } else {
      api.reload('93d27848', component.options)
    }
    module.hot.accept("./Cargo.vue?vue&type=template&id=93d27848&", function () {
      api.rerender('93d27848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/repositories/Cargo.vue"
export default component.exports